import { render, staticRenderFns } from "./Masthead.vue?vue&type=template&id=98001966&scoped=true&"
import script from "./Masthead.vue?vue&type=script&lang=ts&"
export * from "./Masthead.vue?vue&type=script&lang=ts&"
import style0 from "./Masthead.vue?vue&type=style&index=0&id=98001966&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98001966",
  null
  
)

export default component.exports